import { render, staticRenderFns } from "./DetailDutyStationForm.vue?vue&type=template&id=a94ae93a&"
import script from "./DetailDutyStationForm.vue?vue&type=script&lang=js&"
export * from "./DetailDutyStationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports